export const sortServices = (arr: any, sortType: number) => {
	var sortOrder = 1; // default to ascending order

	if (sortType === 1 || sortType === 3) {
		sortOrder = -1; // change to descending order
	}

	var fieldToSort = "offeringTypeId"; // default to sorting by firm name
	if (sortType === 2 || sortType === 3) {
		fieldToSort = "conFirmDataId"; // change to sorting by id
	}
	try {
		arr?.sort((a: any, b: any) => {
			var valA, valB;
			if (fieldToSort === "conFirmDataId") {
				valA = parseInt(a[fieldToSort]);
				valB = parseInt(b[fieldToSort]);
			} else {
				valA = a[fieldToSort].toUpperCase();
				valB = b[fieldToSort].toUpperCase();
			}

			if (valA < valB) {
				return -1 * sortOrder;
			}
			if (valA > valB) {
				return 1 * sortOrder;
			}

			// values must be equal
			return 0;
		});
	} catch {
		return 0;
	}

	return arr;
};

export const sortServicesAdmin = (
	arr: any,
	fieldName: string,
	order: number,
) => {
	let res = [];
	try {
		res = arr?.sort((a: any, b: any) => {
			let fieldA = a[fieldName];
			let fieldB = b[fieldName];
			if (fieldName === "offeringTypeId") {
				let fieldA = a.firmData.fkOfferingTypeId;
				let fieldB = b.firmData.fkOfferingTypeId;
			
				if (fieldA === fieldB) {
					let subFieldA = a.firmName?.toLowerCase();
					let subFieldB = b.firmName?.toLowerCase();
					return subFieldA.localeCompare(subFieldB);
				}
			
				return order === 1 ? fieldA - fieldB : fieldB - fieldA;
			}
			else if (fieldName === "serviceName") {
				fieldA = fieldA?.toLowerCase();
				fieldB = fieldB?.toLowerCase();
				if (order === 1) {
					if (fieldA.localeCompare(fieldB) === 0) {
						let subFieldA = a.firmName?.toLowerCase();
						let subFieldB = b.firmName?.toLowerCase();
						return subFieldA.localeCompare(subFieldB);
					}
					return fieldA.localeCompare(fieldB);
				} else {
					if (fieldA.localeCompare(fieldB) === 0) {
						let subFieldA = a.firmName?.toLowerCase();
						let subFieldB = b.firmName?.toLowerCase();
						return subFieldA.localeCompare(subFieldB);
					}
					return fieldB.localeCompare(fieldA);
				}
			} else if (fieldName === "firmName") {
				fieldA = fieldA?.toLowerCase();
				fieldB = fieldB?.toLowerCase();
				if (order === 1) {
					if (fieldA.localeCompare(fieldB) === 0) {
						let subFieldA = new Date(a.createdDate).getTime();
						let subFieldB = new Date(b.createdDate).getTime();
						return subFieldA - subFieldB;
					}
					return fieldA.localeCompare(fieldB);
				} else {
					if (fieldA.localeCompare(fieldB) === 0) {
						let subFieldA = new Date(a.createdDate).getTime();
						let subFieldB = new Date(b.createdDate).getTime();
						return subFieldA - subFieldB;
					}
					return fieldB.localeCompare(fieldA);
				}
			} else if (fieldName === "createdDate") {
				fieldA = new Date(
					new Date(fieldA).setHours(0, 0, 0, 0),
				).getTime();
				fieldB = new Date(
					new Date(fieldB).setHours(0, 0, 0, 0),
				).getTime();
				if (order === 1) {
					if (fieldA === fieldB) {
						let subFieldA = new Date(a.lastUpdate).getTime();
						let subFieldB = new Date(b.lastUpdate).getTime();
						return subFieldA - subFieldB;
					}
					return fieldA - fieldB;
				} else {
					if (fieldA === fieldB) {
						let subFieldA = new Date(a.lastUpdate).getTime();
						let subFieldB = new Date(b.lastUpdate).getTime();
						return subFieldA - subFieldB;
					}
					return fieldB - fieldA;
				}
			} else if (fieldName === "lastUpdate") {
				fieldA = new Date(
					new Date(fieldA).setHours(0, 0, 0, 0),
				).getTime();
				fieldB = new Date(
					new Date(fieldB).setHours(0, 0, 0, 0),
				).getTime();
				if (order === 1) {
					if (fieldA === fieldB) {
						let subFieldA = a.serviceName?.toLowerCase();
						let subFieldB = b.serviceName?.toLowerCase();
						return subFieldA.localeCompare(subFieldB);
					}
					return fieldA - fieldB;
				} else {
					if (fieldA === fieldB) {
						let subFieldA = a.serviceName?.toLowerCase();
						let subFieldB = b.serviceName?.toLowerCase();
						return subFieldA.localeCompare(subFieldB);
					}
					return fieldB - fieldA;
				}
			} else return fieldA - fieldB;
		});
	} catch {}

	return res;
};

export const compare = (a: any, b: any, fieldName: string) => {
	let fa = a[fieldName],
        fb = b[fieldName];

    // Check if both values are strings
    if (typeof fa === "string" && typeof fb === "string") {
        // If both are strings, compare them case-insensitively using localeCompare
        return fa.toLowerCase().localeCompare(fb.toLowerCase());
    }
    
    // Check if both values are numbers
    if (typeof fa === "number" && typeof fb === "number") {
        // If both are numbers, compare numerically
        return fa - fb;
    }

    // Check if both values are booleans
    if (typeof fa === "boolean" && typeof fb === "boolean") {
        // If both are booleans, compare them
        return (fa === fb ? 0 : fa ? 1 : -1);
    }

    // Handle null values, if either is null, return the one that is not null first
    if (fa === null || fb === null) {
        return fa === null ? -1 : 1;
    }

    // If the values are of different types, compare based on the type
    if (typeof fa !== typeof fb) {
        return typeof fa < typeof fb ? -1 : 1;
    }

    // If no conditions match, return 0 (or it could be considered an error if data is invalid)
    return 0;
};
